//return input query string as an object
export default function(queryString) {
    let result = {},
        re = /([^&=]+)=([^&]*)/g,
        m = re.exec(queryString);

    while (m) {
        result[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
        m = re.exec(queryString);
    }

    return result;
}
